// Colocated Driver.js tour for MyWalletDashboard. Convention: each screen
// with a guided tour ships a sibling <ScreenName>.tour.js that exports its
// tour id and step list, so tour copy sits next to the JSX it points at.

export const MY_WALLET_DASHBOARD_TOUR_ID = 'my-wallet-dashboard-v6';

const MY_ACTIVITY_ROUTE = '/my-activity?tab=payouts';

// hasSoloUser only rewrites the copy on the transaction-actions step,
// where a solo user's tab list ends in "Top up" (a real STK top-up
// that lands in their wallet) rather than "Request Top-Up" (a request
// to an admin, which does not exist for them). The tour id stays at
// its current version because the change is a copy tweak, not a
// step, order, or target change: bumping the id would make every
// returning user replay the tour just to read one line of updated
// prose, which is not warranted.
export const buildMyWalletDashboardTourSteps = (navigate, { hasSoloUser = false } = {}) => [
    {
        title: 'Welcome to your balance dashboard',
        description: 'This is where you see what you can spend, send a payment, and review your recent activity. We will walk through it in a few short steps.',
    },
    {
        element: '[data-tour="wallet-balance-card"]',
        title: 'Your balance right now',
        description: 'This number is what you can spend today. Every payment you send comes straight out of it, so keep half an eye on it as you go.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="wallet-refresh"]',
        title: 'Just topped up?',
        description: 'Tap this refresh icon and we will pull the latest figure for you, so your balance catches up right away.',
        side: 'left',
        align: 'start',
    },
    {
        element: '[data-tour="transaction-actions"]',
        title: 'Send a payment',
        description: hasSoloUser
            ? 'Pick a tab for what you want to do: Buy Goods, Paybill, Send Money to a phone, Pochi la Biashara, or Top up. Fill the form, submit, and we will handle the rest.'
            : 'Pick a tab for what you want to do: Buy Goods, Paybill, Send Money to a phone, Pochi la Biashara, or Request Top-Up. Fill the form, submit, and we will handle the rest.',
        side: 'left',
        align: 'start',
    },
    {
        element: '[data-tour="latest-transactions"]',
        title: 'Your recent moves',
        description: 'Every payment you make lands here with its status. Pending means we are still waiting for M-Pesa to confirm; check back in a moment.',
        side: 'top',
        align: 'start',
    },
    {
        element: '[data-tour="wallet-view-more"]',
        title: 'Want the full story?',
        description: 'Open My Activity for a searchable, filterable view of everything your wallet has done. Tap See full activity and we will take you there.',
        side: 'top',
        align: 'end',
        nextBtnText: 'See full activity',
        onNextClick: (element, step, opts) => {
            opts.driver.destroy();
            navigate(MY_ACTIVITY_ROUTE);
        },
    },
];
